/* eslint-disable @typescript-eslint/camelcase */
import { UserManagerSettings, UserManager } from "oidc-client";
import userStore from "@/store/userStore";
import appSettings from "../ApplicationSettings";

const url = `${window.location.protocol}//${window.location.host}`;

const oidcSettings: UserManagerSettings = {
  authority: appSettings.openIdAuthority,
  client_id: appSettings.openIdClientId,
  redirect_uri: `${url}/signin-oidc`,
  response_type: "id_token token",
  scope: "openid profile dcp-council email roles jjs-staff allow-video allow-collection-issue-edit monthly-report-read monthly-report-admin",
  post_logout_redirect_uri: `${url}`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${url}/signin-oidc-silent`
};

const userManager = new UserManager(oidcSettings);

userManager.events.addAccessTokenExpiring(() => {
  console.debug("access token is expiring");
});

userManager.events.addAccessTokenExpired(() => {
  console.debug("access token expired");
});

userManager.events.addSilentRenewError(error => {
  console.error("silent token renewal error");
  console.error(error);
});

userManager.events.addUserSessionChanged(() => {
  console.debug("session changed");
});

userManager.events.addUserLoaded(user => {
  console.debug("user loaded");
  userStore.setUser(user);
});

userManager.getUser().then(user => userStore.setUser(user));

export default userManager;
